import { render } from "./official-notice.vue?vue&type=template&id=6e8f325e"
import script from "./official-notice.vue?vue&type=script&lang=js"
export * from "./official-notice.vue?vue&type=script&lang=js"

import "./official-notice.vue?vue&type=style&index=0&id=6e8f325e&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__